import { ParticipantRemoveReason } from 'constants/enums.js';

const ParticipantRemovedMessages = {
	[ParticipantRemoveReason.FAILED_TO_GET_INFO]: 'information failed to retrieve.',
};

export default ParticipantRemovedMessages;
